import React, { useEffect, useState } from 'react';
import Checkbox from '../../../../Component/Checkbox/Checkbox';
import Select from 'react-select'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { selectEvent } from '../../../../redux/reducers/settingReducer';
const EventVisibilityAndCalculations = ({ handleSelectEvent }) => {
  const dispatch = useDispatch()
  const selectEventData = useSelector((state) => state?.settingReducer?.selectEvent)
  const handleStaticMode = (value) => {
  };
  const [eventList, setEventList] = useState([]);

  const token = window.localStorage.getItem("token");


  useEffect(() => {

    if (token) {
      axios
        .get(`${process.env.REACT_APP_API_ROOT}` + "/api/get_eventlist/", {
          headers: {
            Authorization: `${token}`, // Assuming it's a Bearer token
          },
        })
        .then((response) => {
          setEventList(response.data.data);

        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, []);

  const eventOptions = useSelector((state) => state?.settingReducer?.eventOptions);



  const getFlattenedEvents = () => {
    const selectedEventsOptions = JSON.parse(localStorage.getItem("selectedEventsOptions")) || {};
    const flattenedEvents = Object.values(selectedEventsOptions).flat();

    return flattenedEvents;
  };

  // Flattened events
  const flattenedEvents = getFlattenedEvents();

  return (
    <div>

      <div>
        <Select
          defaultValue={flattenedEvents}
          isMulti
          name="events"
          options={eventOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={handleSelectEvent}
        />

      </div>


    </div>
  );
};

export default EventVisibilityAndCalculations;

